import styled from 'styled-components';

import { Rating as RatingTP } from '~/src/common/components/Rating/Rating';
import { CatalogItemName } from '~/src/screens/CatalogContent/ContentScreen/layout';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductName = styled(CatalogItemName)`
  font-size: 22px;
  line-height: 24px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

export const Granularity = styled.p`
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

export const GranularityLabel = styled.span`
  font-weight: 500;
`;

export const GranularitySeparator = styled.span`
  margin: 0 8px;
  border-left: 1px solid;
`;

export const PricePerWeight = styled.span`
  color: ${({ theme }) => theme.palette.common.DISABLED};
`;

export const Rating = styled(RatingTP)`
  svg {
    width: 16px;
    height: 16px;
  }

  && p {
    color: ${({ theme }) => theme.palette.common.TEXTS};
  }

  && p:last-child {
    font-weight: 500;
    color: ${({ theme }) => theme.palette.common.TEAL};
  }
`;
